import { homeServerUrl } from "../environment/Environment";
import axiosInstance from "../external-library/axios-interceptor/Interceptor";

const getAllUsers = async () => {
    return await axiosInstance.get(`${homeServerUrl}/admin/users`);
};

const toggleUserEnabled = async (userid, enabled) => {
    return await axiosInstance.put(
        `${homeServerUrl}/admin/users/${userid}/enabled`,
        { value: enabled }
    );
};

const userDetailsGetById = async (userid) => {
    return await axiosInstance.get(`${homeServerUrl}/Admin/${userid}`);
};

export { getAllUsers, userDetailsGetById, toggleUserEnabled };
